// HTML Text als innerHTML ausgeben: https://medium.com/@AAlakkad/angular-2-display-html-without-sanitizing-filtering-17499024b079
import { Pipe, PipeTransform } from '@angular/core';
import { Inject, forwardRef } from '@angular/core';

import { AppComponent } from '../app.component';

import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'dienstleister', pure: false 
})
export class DienstleisterPipe implements PipeTransform {
  constructor(@Inject(forwardRef(() => AppComponent)) public app: AppComponent) {
  }

  transform(content, mode: string /* not in use */) {
    //console.log('DienstleisterPipe.transform() content/mode:', content, mode);
    let dl = this.getDienstleister(content);
    if(dl == null) {
      return null;
    }
    else {
      return `${dl.bezeichnung}`;
   }
  }


  getDienstleister(dlId) {
    if(this.app.dienstleister == null || this.app.dienstleister.length == 0) console.log('DienstleisterPipe.getDienstleister() WARNING! app.dienstleister not available (yet)!');
    let dl = this.app.dienstleister.find( f => f.id == dlId );
    //console.log('DienstleisterPipe.getDienstleister() dienstleister:', dl);
    return dl;
  }

}
